import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const Return = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
        <path d="m12.49 4.01 1.132 1.131-6.074 6.072 11.952-.008.001 1.6-11.925.008 6.046 6.046-1.132 1.132L4.5 12l7.99-7.991z"/>
      </svg>)} {...props}/>));
export default Return;
